import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ApiUrl } from '../constants/apiUrl';
import { VCustomerTerminalMain } from '../models/entities/v-customer-terminal-main';
import { VLogoCustomer } from '../models/entities/v-logo-customer';
import { VLogoDailyExchanges } from '../models/entities/v-logo-daily-exchanges';
import { VLogoItem } from '../models/entities/v-logo-item';
import { VLogoProject } from '../models/entities/v-logo-project';
import { VLogoService } from '../models/entities/v-logo-service';
import { VLogoUnitset } from '../models/entities/v-logo-unitset';
import { VMovement } from '../models/entities/v-movement';
import { ListResponseModel } from '../models/responseModels/list-response-model';
import { ResponseModel } from '../models/responseModels/response-model';

@Injectable({
  providedIn: 'root'
})
export class LogoService {
  constructor(private httpClient: HttpClient, private router: Router, private toastrService: ToastrService) { }

  createOrder(movements: VMovement[]) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Logo/createOrder", movements);
  }

  repeatCreateOrder(movement: VMovement) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Logo/repeatCreateOrder", movement);
  }

  getCustomers(): Observable<ListResponseModel<VLogoCustomer>> {
    return this.httpClient.get<ListResponseModel<VLogoCustomer>>(ApiUrl.url + "Logo/getCustomers");
  }

  getDealers(): Observable<ListResponseModel<VLogoCustomer>> {
    return this.httpClient.get<ListResponseModel<VLogoCustomer>>(ApiUrl.url + "Logo/getDealers");
  }

  getCustomerCodeById(customerId: number): Observable<ListResponseModel<VLogoCustomer>> {
    return this.httpClient.get<ListResponseModel<VLogoCustomer>>(ApiUrl.url + "Logo/getCustomerCodeById?customerId=" + customerId);
  }

  getItems(): Observable<ListResponseModel<VLogoItem>> {
    return this.httpClient.get<ListResponseModel<VLogoItem>>(ApiUrl.url + "Logo/getItems");
  }

  getProjects(): Observable<ListResponseModel<VLogoProject>> {
    return this.httpClient.get<ListResponseModel<VLogoProject>>(ApiUrl.url + "Logo/getProjects");
  }

  getProjectCodeById(projectId: number): Observable<ListResponseModel<VLogoProject>> {
    return this.httpClient.get<ListResponseModel<VLogoProject>>(ApiUrl.url + "Logo/getProjectCodeById?projectId=" + projectId);
  }

  getUnitsets(): Observable<ListResponseModel<VLogoUnitset>> {
    return this.httpClient.get<ListResponseModel<VLogoUnitset>>(ApiUrl.url + "Logo/getUnitsets");
  }

  getServices(): Observable<ListResponseModel<VLogoService>> {
    return this.httpClient.get<ListResponseModel<VLogoService>>(ApiUrl.url + "Logo/getServices");
  }

  getServiceCodeById(serviceId: number): Observable<ListResponseModel<VLogoService>> {
    return this.httpClient.get<ListResponseModel<VLogoService>>(ApiUrl.url + "Logo/getServiceCodeById?serviceId=" + serviceId);
  }

  checkExchanges(movements: VMovement[]) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Logo/checkExchanges", movements);
  }


}
